import React from 'react';

export function useDrag() {
  const [clicked, setClicked] = React.useState(false);
  const [dragging, setDragging] = React.useState(false);
  const position = React.useRef(0);

  const dragStart = React.useCallback((ev: React.MouseEvent) => {
    position.current = ev.clientX;
    setClicked(true);
  }, []);

  const dragStop = React.useCallback(
    () =>
      // NOTE: need some delay so item under cursor won't be clicked
      window.requestAnimationFrame(() => {
        setDragging(false);
        setClicked(false);
      }),
    []
  );
  interface dragMoveProps {
    ev: React.MouseEvent;
    cb: (posDif: number) => void;
  }
  const dragMove = ({ ev, cb }: dragMoveProps) => {
    const newDiff = position.current - ev.clientX;
    const movedEnough = Math.abs(newDiff) > 5;

    if (clicked && movedEnough) {
      setDragging(true);
    }

    if (dragging && movedEnough) {
      position.current = ev.clientX;
      cb(newDiff);
    }
  };

  return {
    dragStart,
    dragStop,
    dragMove,
    dragging,
    position,
    setDragging
  };
}

export function useTouchDrag() {
  const [clicked, setClicked] = React.useState(false);
  const [touching, setTouching] = React.useState(false);
  const position = React.useRef(0);

  const touchDragStart = React.useCallback((ev: React.TouchEvent) => {
    position.current = ev.touches[0].clientX;
    setClicked(true);
  }, []);

  const touchDragStop = React.useCallback(
    () =>
      // NOTE: need some delay so item under cursor won't be clicked
      window.requestAnimationFrame(() => {
        setTouching(false);
        setClicked(false);
      }),
    []
  );

  const touchDragMove = (ev: React.TouchEvent, cb: (posDif: number) => void) => {
    const newDiff = position.current - ev.touches[0].clientX;
    const movedEnough = Math.abs(newDiff) > 5;

    if (clicked && movedEnough) {
      setTouching(true);
    }

    if (touching && movedEnough) {
      position.current = ev.touches[0].clientX;
      cb(newDiff);
    }
  };

  return {
    touchDragStart,
    touchDragStop,
    touchDragMove,
    touching,
    position,
    setTouching
  };
}
